import React, { useState, useEffect } from 'react'
import { Col, Icon, IconButton, Input, Panel, Row, SelectPicker, Table } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { sessionSetItemObj, sessionGetItemJSON } from '../../utils/sessionHelpers'
import { sessionGetItemObj } from '../../utils/sessionHelpers'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { budgetFormat } from '../../utils/formatterUtil'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import { searchCodeCond } from '../../constants/projectIndicatorsCode'
import pathname from '../../constants/pathname'
import { SUB_PROJECT_ID } from '../../constants/constants'
import { getProjectIndicatorsDetails } from '../../redux/actions/projectIndicatorsDetails'
import { doneLoading, startLoading } from '../../utils/loading'

export default function ListProjectIndicatorsDetails({
  schemaIndicators,
  schema,
  loading,
  searchCode,
  year,
  startDate,
  endDate,
  supTeamLeader,
  supported,
  sector,
}) {
  // const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)

  const history = useHistory()
  const { Column, HeaderCell, Cell } = Table
  const projectCode = sessionStorage.getItem('projectCode')
  const { periodNumber } = sessionGetItemObj('periodInfo')
  const periodInfo = sessionGetItemJSON('periodInfo')
  const [displayLength, setDisplayLength] = useState(10)
  const [page, setPage] = useState(1)
  const [totalSize, setTotalSize] = useState(0)
  const [tableData, setTableData] = useState([])
  const [condiStr, setCondiStr] = useState('')
  const [columnDisplayValiable, setColumnDisplayValiable] = useState()

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 10, label: 10 },
    { value: 20, label: 20 },
    { value: 40, label: 40 },
    { value: 50, label: 50 },
  ]

  useEffect(() => {
    let str = ''
    switch (searchCode) {
      case searchCodeCond.PROGRESS_10.SEARCH_CODE:
        str = searchCodeCond.PROGRESS_10.TEXT
        break

      case searchCodeCond.PROGRESS_20.SEARCH_CODE:
        str = searchCodeCond.PROGRESS_20.TEXT
        break

      case searchCodeCond.PROGRESS_40.SEARCH_CODE:
        str = searchCodeCond.PROGRESS_40.TEXT
        break

      case searchCodeCond.PROGRESS_60.SEARCH_CODE:
        str = searchCodeCond.PROGRESS_60.TEXT
        break

      case searchCodeCond.PROGRESS_80.SEARCH_CODE:
        str = searchCodeCond.PROGRESS_80.TEXT
        break

      case searchCodeCond.PROGRESS_100.SEARCH_CODE:
        str = searchCodeCond.PROGRESS_100.TEXT
        break

      case searchCodeCond.INDICATORS_001.SEARCH_CODE:
        str = searchCodeCond.INDICATORS_001.TEXT
        break

      case searchCodeCond.INDICATORS_002.SEARCH_CODE:
        str = searchCodeCond.INDICATORS_002.TEXT
        break

      case searchCodeCond.INDICATORS_003.SEARCH_CODE:
        str = searchCodeCond.INDICATORS_003.TEXT
        break

      case searchCodeCond.INDICATORS_004.SEARCH_CODE:
        str = searchCodeCond.INDICATORS_004.TEXT
        break

      case searchCodeCond.INDICATORS_005.SEARCH_CODE:
        str = searchCodeCond.INDICATORS_005.TEXT
        break

      case searchCodeCond.INDICATORS_006.SEARCH_CODE:
        str = searchCodeCond.INDICATORS_006.TEXT
        break

      case searchCodeCond.INDICATORS_007.SEARCH_CODE:
        str = searchCodeCond.INDICATORS_007.TEXT
        break

      case searchCodeCond.INDICATORS_008.SEARCH_CODE:
        str = searchCodeCond.INDICATORS_008.TEXT
        break

      case searchCodeCond.INDICATORS_009.SEARCH_CODE:
        str = searchCodeCond.INDICATORS_009.TEXT
        break

      case searchCodeCond.INDICATORS_010.SEARCH_CODE:
        str = searchCodeCond.INDICATORS_010.TEXT
        break

      case searchCodeCond.INDICATORS_011.SEARCH_CODE:
        str = searchCodeCond.INDICATORS_011.TEXT
        break

      case searchCodeCond.INDICATORS_012.SEARCH_CODE:
        str = searchCodeCond.INDICATORS_012.TEXT
        break

      case searchCodeCond.RISK_3.SEARCH_CODE:
        str = searchCodeCond.RISK_3.TEXT
        break

      case searchCodeCond.RISK_2.SEARCH_CODE:
        str = searchCodeCond.RISK_2.TEXT
        break

      case searchCodeCond.RISK_1.SEARCH_CODE:
        str = searchCodeCond.RISK_1.TEXT
        break

      case searchCodeCond.RISK_0.SEARCH_CODE:
        str = searchCodeCond.RISK_0.TEXT
        break

      default:
        str = 'ไม่พบข้อมูล'
        break
    }
    console.log('ggg = ', schema.datas.columnDisplayValueStatus)
    setCondiStr(str)
    setTableData(schema.datas.values || [])
    setTotalSize(schema.datas.totalSize || 0)
    setColumnDisplayValiable(schema.datas.columnDisplayValueStatus)
  }, [formSchema])

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    onReloadData(dataKey, 1)
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage 111 page', dataKey)

    setPage(dataKey)
    onReloadData(displayLength, dataKey)
  }

  const onReloadData = async (pageSize, pageNumber) => {
    startLoading()
    try {
      const _schema = await getProjectIndicatorsDetails(
        searchCode,
        year,
        startDate,
        endDate,
        supTeamLeader,
        supported,
        sector,
        pageSize,
        pageNumber
      )

      // console.log('errrrr => ', _schema.datas.values)
      setTableData(_schema.datas.values || [])
      setTotalSize(_schema.datas.totalSize || 0)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded bordered>
        <div style={{ marginBottom: 20, marginTop: 20 }}>
          <h6>เงื่อนไข : {condiStr}</h6>
          <br />
          {/* <Row style={{ marginBottom: 10 }}>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schemaIndicators.year.label}
              <Input value={year} disabled />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schemaIndicators.startDate.label}
              <Input value={startDate} disabled />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schemaIndicators.endDate.label}
              <Input value={endDate} disabled />
            </Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schemaIndicators.supTeamLeader.label}
              <Input value={supTeamLeader} disabled />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schemaIndicators.supported.label}
              <Input value={supported} disabled />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schemaIndicators.sector.label}
              <Input value={sector} disabled />
            </Col>
          </Row> */}
        </div>

        <Table
          wordWrap
          // height={350}
          // autoHeight={tableData.length < 10}
          minHeight={500}
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: 10 }}
        >
          <Column width={90} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1 + (page * displayLength - displayLength)
              }}
            </Cell>
          </Column>

          <Column width={150}>
            <HeaderCell>รหัสโครงการหลัก</HeaderCell>
            <Cell dataKey="projectCode" />
          </Column>
          <Column width={150}>
            <HeaderCell>รหัสโครงการย่อย</HeaderCell>
            <Cell dataKey="subProjectCode" />
          </Column>
          <Column width={300}>
            <HeaderCell>ชื่อโครงการย่อย</HeaderCell>
            <Cell dataKey="subProjectName" />
          </Column>
          <Column width={220}>
            <HeaderCell>ผู้รับผิดชอบโครการ</HeaderCell>
            <Cell dataKey="responsiblerLabel" />
          </Column>
          <Column width={220}>
            <HeaderCell>ผู้รับทุนโครงการ</HeaderCell>
            <Cell dataKey="granteeSubProjectCode" />
          </Column>
          <Column width={180} align="right">
            <HeaderCell>งบประมาณโครงการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.projectCost || 0)
              }}
            </Cell>
          </Column>
          <Column width={300}>
            <HeaderCell>วันที่เริ่มต้นโครงการ วันที่สิ้นสุดโครงการ</HeaderCell>
            <Cell dataKey="projectStartAndendDate" />
          </Column>
          <Column width={150}>
            <HeaderCell>สถานะโครงการ</HeaderCell>
            <Cell dataKey="projectStatusName" />
          </Column>

          {columnDisplayValiable && (
            <Column width={200}>
              <HeaderCell>{condiStr}</HeaderCell>
              <Cell dataKey="displayValue" />
            </Column>
          )}

          <Column width={150} fixed="right">
            <HeaderCell>จัดการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <ViewButton
                    icon="eye"
                    onClick={() => {
                      // console.log('rowdata => ', rowData)
                      // sessionStorage.setItem('projectId', rowData.id)
                      sessionStorage.setItem(SUB_PROJECT_ID, rowData.id)
                      sessionStorage.setItem('param', '')

                      history.push({
                        pathname: `${pathname.subProject.overviewSubProject}`,
                      })
                    }}
                  >
                    แสดง
                  </ViewButton>
                )
              }}
            </Cell>
          </Column>
        </Table>

        <TablePagination
          lengthMenu={defaultLengthMenu}
          activePage={page}
          renderLengthMenu={(lengthMenu) => {
            return (
              <>
                {lengthMenu}
                {`รายการ/หน้า`}
              </>
            )
          }}
          renderTotal={(total) => {
            return <>{` ทั้งหมด ${total} รายการ`}</>
          }}
          displayLength={displayLength || 5}
          total={totalSize}
          onChangePage={handleChangePage}
          onChangeLength={handleChangeLength}
        />

        {isLoading && <OverlayLoader />}
      </Panel>
    </>
  )
}
